// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"edf2b49a","outerContainer":"cf52bb24","secondaryToolbar":"_643a0147","doorHangerRight":"b31f0d12","toolbarContainer":"_3e54f8b8","toolbarViewerMiddle":"ed2a7d07","progressBar":"_5a9d9f7d","back-to-application":"_622545bf","root":"a092373d","viewAttachmentWrapper":"_960169b4","documentWrapper":"_7512ed10","icon":"_4a2eef26","addButtonTitle":"_5c502c09","addActionWrapper":"d639e33c","disabled":"fb0c269f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/VisitDocuments/UploadDocument/index.styl
// module id = 4991
// module chunks = 39